module.exports = __webpack_public_path__ + "img/FJIBCNBAXXX.2b4b7471.png";